import { type Control, Controller, type FieldValues, type Path } from 'react-hook-form';
import Checkbox, { type CheckboxProps } from '../Checkbox';

interface Props<T extends FieldValues> extends Omit<CheckboxProps, 'checked' | 'onChange' | 'value'> {
  name: Path<T>;
  control: Control<T>;
}

export default function <T extends FieldValues>({ name, control, ...props }: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: props.required ? 'Required' : false }}
      render={({ field }) => <Checkbox {...props} {...field} checked={field.value} />}
    />
  );
}
